import React from 'react';
import constants from '../constants';

const year = constants.currentSeason;

export const teamDetailsModule = ({ teamName, yahooTeamUrl, teamImage, currentRank, record }) => (
    <div>
        <div className="text-center">
            <a href={yahooTeamUrl} target="_blank" rel="noopener noreferrer" className='btn btn-link'>
                <div className='d-flex' style={{fontSize: '18px'}}>
                    {teamName} <i className="bi bi-box-arrow-up-right" style={{fontSize: '10px'}}></i>
                </div>
            </a>
        </div>
        <div className="d-flex flex-row justify-content-between align-items-center">
            <img src={teamImage} className="img-fluid" style={{height: '30px', width: '30px'}} alt={`${teamName} logo`}></img>
            <div>
                <div>{year} Record - {record}</div>
                <div>{year} Rank - {currentRank}</div>
            </div>
        </div>
    </div>
);